export default function PHTile({ label, ratio = 1, from, to, kind = 'image', dur, radius = 10 }) {
  return (
    <div className="ph" style={{
      aspectRatio: ratio,
      borderRadius: radius,
      border: '1px solid rgba(255,255,255,.08)',
      '--ph-from': from,
      '--ph-to': to,
      width: '100%',
    }}>
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', padding: 8, zIndex: 2 }}>
        {label && (
          <span className="mono" style={{ fontSize: 9, color: 'rgba(255,255,255,.7)', letterSpacing: '.04em' }}>{label}</span>
        )}
        {kind === 'video' && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 9, color: 'rgba(255,255,255,.8)' }}>
            <svg width={8} height={8} viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M8 5v14l11-7z"/></svg>
            <span className="mono">{dur || '0:04'}</span>
          </span>
        )}
      </div>
    </div>
  );
}
